<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Unidade Regional</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              label="Unidade Regional"
              name="nome"
              type="text"
              required
              v-model="payload.nomeRegiao"
            ></v-text-field>
          </v-col>
          <v-col v-if="this.edit">
            <combobox-municipio
              :multiple="true"
              :value="payload"
              :filterByUnidadeRegional="this.payload.id_unidade_regional"
              @byRegional="(e) => (municipiosRegionais = e)"
            ></combobox-municipio>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.gerente"
              label="Nome Completo do Gerente"
              name="gerente"
              type="text"
              hide-details="auto"
              placeholder="nome completo do gerente"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.telefoneFixo"
              label="Telefone"
              name="telefone"
              type="text"
              v-mask="'(##) ####-####'"
              hide-details="auto"
              placeholder="(00) 0000-0000"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="payload.telefoneCelular"
              label="Celular"
              name="celular"
              type="text"
              v-mask="'(##) #####-####'"
              hide-details="auto"
              placeholder="(00) 00000-0000"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { urAPI } from "../API/urAPI";
import ComboboxMunicipio from "@/modules/ur/components/ComboboxMunicipioRegional";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertUr",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  components: {
    ComboboxMunicipio,
  },
  data() {
    return {
      payload: {},
      dialog: false,
      municipiosRegionais: [],
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = this.object;
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      this.payload.uf = this.$store.state.uf;
      if (this.edit === true) {
        urAPI
          .update(this.payload)
          .then((resp) => {
            this.dialog = false;
            if (this.payload.municipioId) {
              const remover = this.municipiosRegionais
                .filter((item) => !this.payload.municipioId.includes(item))
                .map((item) => ({
                  idUnidadeRegional: 0,
                  municipioId: item,
                }));

              let newObj = this.payload.municipioId.map((item) => ({
                idUnidadeRegional: this.payload.id_unidade_regional,
                municipioId: item,
              }));

              newObj = [...newObj, ...remover];

              urAPI
                .atualizarMunicipios(newObj)
                .then((_) => {
                  this.setLoading(false);
                })
                .catch((e) => {
                  console.log("error on modalinsert ur: ", e);
                  this.$notification.error(
                    "Error ao atulizar municipios na UR"
                  );
                  this.setLoading(false);
                });
            }
            this.$emit("on-save");
          })
          .catch((e) => {
            console.log("error on modalinsert ur: ", e);
            this.$notification.error("Error ao salvar UR");
            this.setLoading(false);
          });
      } else {
        urAPI
          .create(this.payload)
          .then((resp) => {
            this.dialog = false;
            this.setLoading(false);

            this.$emit("on-save");
          })
          .catch((e) => {
            console.log("error on modalinsert ur: ", e);
            this.$notification.error("Error ao salvar UR");
            this.setLoading(false);
          });
      }
    },
  },
};
</script>
